import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { FullAvailabilityTemplateFragment } from '../../../generated/graphql.generated';
import { AvailabilityEventTypes } from '../../availability/availability.util';
import { getTextColorForBackground } from '../../utilities/color.util';

@Component({
  selector: 'app-availability-template-event',
  templateUrl: './availability-template-event.component.html',
  styleUrls: ['./availability-template-event.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class AvailabilityTemplateEventComponent {
  @Input() template: FullAvailabilityTemplateFragment;
  @Input() type: string;
  @Input() overriden: boolean;

  AvailabilityEventTypes = AvailabilityEventTypes;

  get isOverriddenButNotOverrideType() {
    return this.overriden && this.type !== AvailabilityEventTypes.override;
  }

  getTextColor(color: string) {
    return getTextColorForBackground(color || '#81D4FA');
  }
}
